import{a as e,d as n}from"./chunk-IGKZHVES.js";import{a as c}from"./chunk-WDXTVGVS.js";import{e as t}from"./chunk-TCREYWFW.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();n();function u(r){e.dispatch(t(r))}export{u as a};
//# sourceMappingURL=chunk-6WYDJP3Z.js.map
